<template>
<div class="head-home">
  <div class="">
    <div class="container ">
      <div class="row">
        <div class="col">
          <div class="brand">
            <h1 class="YILMER-VIVAS">YILMER <br> VIVAS</h1>
            <h3 class="sub-title">Drummer / Composer / Producer / Educator </h3>
            <h3 class="sub-title"></h3>
             

            <div class="text-center scl">
              <a target="_blank" href="https://www.instagram.com/yilmervr/"><img class="social-media" src="../assets/instagram.png" alt="instagram"></a>
              <a target="_blank" href="https://www.youtube.com/channel/UC63lp7dqwdxIbYk1shbeVWA"><img class="social-media" src="../assets/youtube.png" alt="Youtube"></a>
              <a target="_blank" href="https://www.facebook.com/yilmervr"><img class="social-media" src="../assets/facebook.png" alt="facebook"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'name',
  data() {
    return {

    }
  }
}

</script>

<style scoped="">
.brand {
  margin-top: 35%;
  margin-left: 60%;
}

.head-home {
  background: url(../assets/home.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  height: 53.38rem !important;
  max-height: 53.38rem !important;
}

.head-home:before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 53.38rem !important;
  top: 0rem;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(65, 60, 60, 0.5);
  transition: all .3s linear;
}

.overlay {
  width: 100%;
  height: 100%;
  opacity: 0.7;
  background-color: #413c3c;
}

.YILMER-VIVAS {
  font-family: 'Open Sans', sans-serif;
  font-size: 100px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.01;
  letter-spacing: -0.1px;
  text-align: justify;
  color: #ffffff;
}

.sub-title {
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: left;
  color: #d6d6d6;
}

.social-media {
  padding-left: 3rem;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.social-media:hover{
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.scl {
  padding-top: 1rem;
}

@media (min-width: 768px) and (max-width: 991px) {
  .brand {
    margin-top: 55%;
    margin-left: 69%;
  }
  .social-media {
    padding-left: 2rem;
    width: 67px
  }
  .YILMER-VIVAS {
    font-size: 80px;
  }
}

@media (max-width: 767px) {
  .YILMER-VIVAS {
    font-size: 40px;
  }
  .head-home {
    height: 25.38rem !important;
  }
  .head-home:before {
    height: 25.38rem !important;
  }
  .sub-title {
    font-size: 18px;
  }
  .social-media {
    padding-left: 1rem;
    width: 45px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionHead.vue